/**
 * Authentication utilities
 */

/**
 * Syncs tokens across different storage locations
 * @param accessToken The access token to store
 */
export const syncTokenStorage = async (accessToken: string): Promise<void> => {
  localStorage.setItem("access_token", accessToken);
  // Any other token sync logic would go here
};

/**
 * Clears all stored tokens and authentication data
 */
export const clearTokenStorage = (): void => {
  localStorage.removeItem("access_token");
  // Any other token cleanup would go here
}; 